module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "c-element-definition d-flex flex-column justify-content-between"
  }, [_c('dt', {
    staticClass: "c-element-definition__symbol align-self-center"
  }, [_vm._v(_vm._s(_vm.element.symbol))]), _vm._v(" "), (_vm.detailed) ? _c('dd', {
    staticClass: "c-element-definition__top flex-first d-flex justify-content-between"
  }, [_c('span', {
    staticClass: "c-element-definition__atomic-mass text-truncate"
  }, [(_vm.simpleView) ? _c('span', [_vm._v(_vm._s(_vm.element.atomicMass))]) : _vm._e()]), _vm._v(" "), _c('span', {
    staticClass: "c-element-definition__atomic-number"
  }, [_vm._v(_vm._s(_vm.element.atomicNumber))])]) : _vm._e(), _vm._v(" "), (_vm.detailed) ? _c('dd', {
    staticClass: "c-element-definition__name text-center text-truncate"
  }, [_vm._v(_vm._s(_vm.element.name))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6517a1fa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ElementDefinition.vue
// module id = 644
// module chunks = 1